type GTMEvent = {
    event: string;
    category: string;
    action: string;
    label?: string;
};

export const pushGTMEvent = ({ event, category, action, label }: GTMEvent) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event,
        category,
        action,
        label,
    });
};
